import React, { useState } from "react";
import { Input, Form, Select, Spin  } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getGovernments } from "../../../redux/slices/governments/governmentsThunk";

const { Option } = Select;

const FormFields = () => {
  const [limit, setLimit] = useState(10)
  const dispatch = useDispatch();

  const governments_data = useSelector((state) => state.governments.governments);
  const governments_loading = useSelector((state) => state.governments.loading);
  const hasNextPage = governments_data?.hasNextPage; // Assuming this flag indicates if more data is available

  const handleScroll = (event) => {
    const { target } = event;
    if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
      if (hasNextPage) {
        setLimit(limit + 10)
        dispatch(getGovernments({ page: 1, limit: limit }));
      }
    }
  };
  return (
    <>
      <Form.Item
        name="name"
        label="Région"
        rules={[
          {
            required: true,
            message: "S'il vous plaît entrer le nom de la région",
          },
        ]}
      >
        <Input placeholder="Entrez le nom de la région" />
      </Form.Item>
      <Form.Item
        name="government"
        label="Gouvernorat"
        rules={[
          {
            required: true,
            message: "S'il vous plaît Choisirune Gouvernorat",
          },
        ]}
      >
        <Select
          placeholder="Choisir une Gouvernorat"
          allowClear
          style={{ width: "100%" }}
          loading={governments_loading}
          onPopupScroll={handleScroll}
          notFoundContent={governments_loading ? <Spin size="small" /> : null} // Show a loading spinner if loading
        >
          {governments_data?.data?.map((gouvernorat) => (
            <Option key={gouvernorat.id} value={gouvernorat.id}>
              {gouvernorat.name}
            </Option>
          ))}
        </Select>
      </Form.Item>
    </>
  );
};

export default FormFields;
